import i18next from 'i18next';
import React from 'react';

import { Button } from '@commons/utils/styledLibraryComponents';

const CLONE_ICON = '/images/inpulse/gear-ipblack-small.svg';
const REMOVE_ICON = '/images/inpulse/remove-black-small.svg';
const EDIT_PRICE_ICON = '/images/inpulse/edit-pen-black-small.svg';
const EXPORT_ICON = '/images/inpulse/file-download-black-small.svg';

export const getActions = ({
  canEdit,
  hasSelection,
  onAdd,
  onClone,
  onExport,
  onRemoveSelection,
}) => {
  const exportAction = {
    id: 'export-catalog',
    actionLabel: i18next.t(
      hasSelection ? 'GENERAL.EXPORT_SELECTION' : 'EXTERNAL_CLIENTS.LIST.EXPORT_CATALOG',
    ),
    actionIcon: () => EXPORT_ICON,
    handleAction: onExport,
  };

  if (!canEdit) {
    return [exportAction];
  }

  const actions = [
    {
      id: 'add-catalog-products',
      actionLabel: i18next.t('GENERAL.ADD'),
      fixed: true,
      render: () => (
        <Button
          color={'inpulse-default'}
          handleClick={onAdd}
          icon={'/images/inpulse/add-white-small.svg'}
          label={i18next.t('GENERAL.ADD')}
        />
      ),
      handleAction: () => {},
    },
    exportAction,
  ];

  if (hasSelection) {
    actions.push({
      id: 'remove-catalog-selection',
      actionLabel: i18next.t('EXTERNAL_CLIENTS.CATALOG.REMOVE_SELECTION_ACTION'),
      actionIcon: () => REMOVE_ICON,
      handleAction: onRemoveSelection,
    });

    return actions;
  }

  actions.push({
    id: 'clone-catalog',
    actionLabel: i18next.t('EXTERNAL_CLIENTS.CATALOG.CLONE_ACTION'),
    actionIcon: () => CLONE_ICON,
    handleAction: onClone,
  });

  return actions;
};

/**
 * Row actions of the catalog list: edit the TTC price, or remove the product from the catalog.
 * Only built for users owning the `external-client:edit` right.
 */
export const getRowActions = ({ onEditPrice, onRemove }) => [
  {
    id: 'edit-catalog-product-price',
    actionLabel: () => i18next.t('EXTERNAL_CLIENTS.CATALOG.EDIT_PRICE_ACTION'),
    actionIcon: () => EDIT_PRICE_ICON,
    handleAction: onEditPrice,
  },
  {
    id: 'remove-catalog-product',
    actionLabel: () => i18next.t('EXTERNAL_CLIENTS.CATALOG.REMOVE_ACTION'),
    actionIcon: () => REMOVE_ICON,
    handleAction: onRemove,
  },
];
